export const VISIT_PLANS_TABLE_UNIQUE_ID = 'visit-plans';

export const VISIT_PLANS_TABLE_ROW_HEIGHT = 48;

// Keep in sync with the column widths in scheduling-project-visit-plans-table.scss
export const DEFAULT_VISIT_PLANS_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-visit-plan-name': 320,
  'col-template': 180,
  'col-status': 120,
  'col-dates': 200,
  'col-service-time-provider': 200,
  'col-units-provider': 180,
  'col-delivery-time-provider': 180,
  'col-branches': 160,
  'col-created-by': 140
};
